import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useRegistration } from './RegistrationContext';
import StepIndicator from './StepIndicator';
import FormInput from '../common/FormInput';
import MainLayout from '../common/MainLayout';
import PhoneInput from '../common/PhoneInput';

function PersonalDetails() {
  const navigate = useNavigate();
  const { registrationData, updateRegistrationData } = useRegistration();

  const handleChange = e => {
    const { name, value } = e.target;
    updateRegistrationData({ [name]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    navigate('address');
  };

  return (
    <MainLayout>
      <StepIndicator currentStep={1} />

      <h2 className="text-2xl font-bold mb-8 text-hdlcc-textPrimary tracking-tight">
        Personal Details
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-6">
          <FormInput
            label="First Name"
            name="firstName"
            value={registrationData.firstName || ''}
            onChange={handleChange}
          />

          <FormInput
            label="Last Name"
            name="lastName"
            value={registrationData.lastName || ''}
            onChange={handleChange}
          />
        </div>

        <FormInput
          label="Email"
          name="email"
          type="email"
          value={registrationData.email || ''}
          onChange={handleChange}
        />

        <PhoneInput
          label="Phone"
          name="phone"
          value={registrationData.phone || ''}
          onChange={handleChange}
        />

        <FormInput
          label="Date of Birth"
          name="dateOfBirth"
          type="date"
          value={registrationData.dateOfBirth || ''}
          onChange={handleChange}
        />

        <div className="mt-8 flex justify-end">
          <button
            type="submit"
            className="bg-gradient-to-r from-hdlcc-primary to-hdlcc-primaryLight text-white px-8 py-3 rounded-xl hover:shadow-glow-primary transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Next: Address Details
          </button>
        </div>
      </form>
    </MainLayout>
  );
}

export default PersonalDetails;
